import { useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

import getParams from 'utils/getParams';
import * as auditApi from '_api/audit';

import config from './config';


const Auth0ProviderWrapper = ({
  children,
  organizationId,
  clientId,
  organizationDomain,
  altOrganizationDomain,
  altOrganizationId,
  altClientId }) => {
  const navigate = useNavigate();
  const { blink_id = null } = getParams();
  const state = blink_id ? `?blink_id=${blink_id}` : '';

  const path = window.location.pathname;
  const isLoginRoute = path === '/' || path === '/login' || path === '/login-blink';

  const windowPath = isLoginRoute ? config.defaultPath : path;

  const isLoginBlink =   window.location.pathname === '/login-blink';

  const onRedirectCallback = (appState = {}, { email }) => {
    if (appState.redirectTo) {
      navigate(appState.redirectTo);
    }

    auditApi.loginSuccess(email);
  };

  return (
    <Auth0Provider
      domain={isLoginBlink ? altOrganizationDomain : organizationDomain}
      clientId={isLoginBlink ? altClientId : clientId}
      authorizationParams={{
        redirect_uri: window.location.origin + windowPath + state,
        ...(organizationId && !isLoginBlink && { organization: organizationId }),
        ...(altOrganizationId && isLoginBlink && { organization: altOrganizationId }),
      }}
      useRefreshTokens
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWrapper;
